import { useMemo } from 'react';
import { regionService } from '~/features/region/regionService';
import { regionPersistences } from '~/persistence';

export const useRegion = () => {
  const regionCode = regionPersistences.Data.value ?? 'jp';

  const ARegionName = useMemo(() => {
    return regionService.getARegionName(regionCode);
  }, [regionCode]);

  const isAJP = useMemo<boolean>(() => {
    return ARegionName === 'AJP';
  }, [ARegionName]);

  return { ARegionName, isAJP, regionCode };
};
